var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$loader.loading)?_c('div',{staticClass:"absolute bg-opacity-50 bg-white h-screen w-screen z-99"},[_c('gd-loader')],1):_vm._e(),_c('loading',{ref:"loading",attrs:{"blur":''}}),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }